import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POILakeStateFields from "@/components/POI/POIStateFields/POILakeStateFields/POILakeStateFields.vue";

export default {
  components: { POIStep, POILakeStateFields },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
